import { inject } from '@angular/core';
import { Router, UrlTree, CanMatchFn } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

export const authMatchGuard: CanMatchFn = (): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isLogIn() ? true : router.createUrlTree(['/auth/login']);
};
